'use client'

import { useEffect } from 'react'

/**
 * Last resort: this replaces the root layout, so it fires when the layout
 * itself threw. Nothing from the app is assumed to be working - no
 * ThemeProvider, no globals.css, no fonts, no next/image. Everything here is
 * inline and self-contained on purpose; a fallback that depends on the thing
 * that just broke is not a fallback.
 *
 * Colours are the CSS system keywords (Canvas/CanvasText) under
 * `color-scheme: light dark`, so the page still follows the visitor's OS theme
 * without a provider or a media query.
 */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }, reset: () => void }) {
  useEffect(() => { console.error(error) }, [error])

  return (
    <html lang="mn">
      <body style={{ margin: 0, colorScheme: 'light dark', background: 'Canvas', color: 'CanvasText' }}>
        <main style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '0 1.5rem',
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
        }}>
          <p style={{ margin: '0 0 2rem', fontSize: '0.875rem', letterSpacing: '0.08em', textTransform: 'uppercase', opacity: 0.55 }}>
            Shop.mn Domain
          </p>

          <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.01em' }}>
            Ямар нэгэн алдаа гарлаа
          </h1>
          <p style={{ margin: '0.75rem 0 0', fontSize: '0.9375rem', opacity: 0.65, maxWidth: '28rem' }}>
            Хуудсыг ачаалж чадсангүй. Түр хүлээгээд дахин оролдоно уу.
          </p>

          <button
            type="button"
            onClick={() => reset()}
            style={{
              marginTop: '2rem',
              padding: '0.625rem 1.25rem',
              borderRadius: '9999px',
              border: '1px solid currentColor',
              background: 'transparent',
              color: 'inherit',
              font: 'inherit',
              fontSize: '0.875rem',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Дахин оролдох
          </button>

          { error.digest ? (
            <p style={{ margin: '2.5rem 0 0', fontSize: '0.75rem', opacity: 0.45 }}>
              Алдааны дугаар: {error.digest}
            </p>
          ) : null }
        </main>
      </body>
    </html>
  )
}
